import { IAppStateModel } from '@models/IAppStateModel';

export const $selectAllBrandkits = (state: IAppStateModel) => state.brandkits;
